import {Storage} from '../configs'

import {
    Tags_GR_DETAIL,
    Tags_GR_ITEM,
    Tags_GR_ITEM_ACCOUNT_ASSIGNMENT,
    Tags_GR_SERVICE,
    Tags_GR_SERVICELINE,
    Tags_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
    Tags_IR_DETAIL,
    Tags_IR_ITEM,
    Tags_IR_ITEM_ACCOUNT_ASSIGNMENT,
    Tags_IR_SERVICELINE,
    Tags_IR_ONE_TIME_VENDOR,
    Tags_MR_DETAIL,
    Tags_MR_ATTACHMENTS,
    Tags_MR_VENDOR
}
from '../configs/tagsConfig'


let tagsConfigHelper={}

const findTagConfig =(tagId,docType)=>{
    let result=null
    let tagsConfigs=Storage.getControlConfigs()
    let role=Storage.getRole()

    if (tagsConfigs && tagId && docType){
        result=tagsConfigs.find(f=>
        f.role_Id===role
        && f.tag_Id.toLowerCase() === tagId.toLowerCase()
        && f.document_Type ===docType)
    }

    // console.log("findTagConfig()",tagId)
    // console.log("findTagConfig()",role)
    // console.log("findTagConfig()",docType)
    // console.log("findTagConfig()",tagId)
    // console.log(JSON.stringify(tagsConfigs))
    // console.log(result)

    return result
}

const checkRequired=(data,field,docType,configs)=>{
   if(!configs) return

   let errors=[]

    configs.forEach(element => {
        let tagConfig=findTagConfig(element.tagId, element.docType || docType )

        if(tagConfig){
            let tagId= element.tagId
            let field=element.field
            let required=tagConfig.required
            let description=tagConfig.description

        if(required){
            if(!data || data[field] || data[field].toString().length===0){
                let error="กรุณาระบุ " + (description!==null ? tagId :description)

                errors=[...errors,error]
            }
        }
        }
    })

    return errors
}

const validate_GR=(datas)=>{
    console.group("validate_GR")
    console.log("datas:")
    console.log(datas)

    let errors=[]
    let errors_gr_detail=[]
    let errors_gr_item=[]
    let errors_gr_item_account_assignment=[]
    let errors_gr_service=[]
    let errors_gr_serviceline=[]
    let errors_gr_serviceline_account_assignmnet=[]

    let t_GR_DETAIL=datas.t_GR_DETAIL
    let t_GR_ITEM=datas.t_GR_ITEM
    let t_GR_ITEM_ACCOUNT_ASSIGNMENT=datas.t_GR_ITEM_ACCOUNT_ASSIGNMENT
    let t_GR_SERVICE=datas.t_GR_SERVICE
    let t_GR_SERVICELINE=datas.t_GR_SERVICELINE
    let t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT=datas.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT

    errors_gr_detail=checkRequired(t_GR_DETAIL,Tags_GR_DETAIL)

    //## Purchase  ##
    if(t_GR_ITEM){
        t_GR_ITEM.forEach((item)=>{
            if(parseInt(item.checked)===1){
                errors_gr_item =checkRequired(item, Tags_GR_ITEM)

                if(t_GR_ITEM_ACCOUNT_ASSIGNMENT){
                    const t_GR_ITEM_ACCOUNT_ASSIGNMENT_filtered=t_GR_ITEM_ACCOUNT_ASSIGNMENT
                    .filter(f=>parseInt(f.checked)===1 && f.acc_id===item.item_no)

                    errors_gr_item_account_assignment=checkRequired(t_GR_ITEM_ACCOUNT_ASSIGNMENT_filtered,Tags_GR_ITEM_ACCOUNT_ASSIGNMENT)
                }
            }
        })
    }
    //## End of Purchase  ##

    //## Service  ##
    if(t_GR_SERVICE){
        t_GR_SERVICE.forEach((item)=>{
        if(parseInt(item.checked)===1){
            errors_gr_service =checkRequired(item, Tags_GR_SERVICE)

            if(t_GR_SERVICELINE){
                const t_GR_SERVICELINE_filterd=t_GR_SERVICELINE
                .filter(f=>parseInt(f.checked)===1 
                && f.service_item_no===item.service_item_no)

                errors_gr_serviceline=checkRequired(t_GR_SERVICELINE_filterd,Tags_GR_SERVICELINE)
           
                if(t_GR_SERVICELINE_filterd && t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT){
                    const t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT_filterd=t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
                    .filter(f=>parseInt(f.checked)===1 
                    && f.item_no === item.service_item_no
                    && f.acc_id === item.service_line_no)

                    errors_gr_serviceline_account_assignmnet=checkRequired(t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT_filterd,Tags_GR_SERVICELINE_ACCOUNT_ASSIGNMENT)
                }
            }
        }
    })
    }
    //## End of Service  ##

    errors={
        ...errors_gr_detail,
        ...errors_gr_item,
        ...errors_gr_item_account_assignment,
        ...errors_gr_service,
        ...errors_gr_serviceline,
        ...errors_gr_serviceline_account_assignmnet
    }

    console.groupEnd()

    return errors
}

const validate_ItemModal=(datas)=>{
    console.group("validate_ItemModal")
    console.log("datas:")
    console.log(datas)

    let errors=[]
    let errors_gr_item=[]
    let errors_gr_item_account_assignment=[]
    let errors_gr_service=[]
    let errors_gr_serviceline=[]
    let errors_gr_serviceline_account_assignmnet=[]

    let t_GR_ITEM=datas.t_GR_ITEM
    let t_GR_ITEM_ACCOUNT_ASSIGNMENT=datas.t_GR_ITEM_ACCOUNT_ASSIGNMENT
    let t_GR_SERVICE=datas.t_GR_SERVICE
    let t_GR_SERVICELINE=datas.t_GR_SERVICELINE
    let t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT=datas.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT

    //## Purchase  ##
    if(t_GR_ITEM){
        t_GR_ITEM.forEach((item)=>{
            if(parseInt(item.checked)===1){
                errors_gr_item =checkRequired(item, Tags_GR_ITEM)

                if(t_GR_ITEM_ACCOUNT_ASSIGNMENT){
                    const t_GR_ITEM_ACCOUNT_ASSIGNMENT_filtered=t_GR_ITEM_ACCOUNT_ASSIGNMENT
                    .filter(f=>parseInt(f.checked)===1 && f.acc_id===item.item_no)

                    errors_gr_item_account_assignment=checkRequired(t_GR_ITEM_ACCOUNT_ASSIGNMENT_filtered,Tags_GR_ITEM_ACCOUNT_ASSIGNMENT)
                }
            }
        })
    }
    //## End of Purchase  ##

    //## Service  ##
    if(t_GR_SERVICE){
        t_GR_SERVICE.forEach((item)=>{
        if(parseInt(item.checked)===1){
            errors_gr_service =checkRequired(item, Tags_GR_SERVICE)

            if(t_GR_SERVICELINE){
                const t_GR_SERVICELINE_filterd=t_GR_SERVICELINE
                .filter(f=>parseInt(f.checked)===1 
                && f.service_item_no===item.service_item_no)

                errors_gr_serviceline=checkRequired(t_GR_SERVICELINE_filterd,Tags_GR_SERVICELINE)
           
                if(t_GR_SERVICELINE_filterd && t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT){
                    const t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT_filterd=t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
                    .filter(f=>parseInt(f.checked)===1 
                    && f.item_no === item.service_item_no
                    && f.acc_id === item.service_line_no)

                    errors_gr_serviceline_account_assignmnet=checkRequired(t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT_filterd,Tags_GR_SERVICELINE_ACCOUNT_ASSIGNMENT)
                }
            }
        }
    })
    }
    //## End of Service  ##

    errors={
        ...errors_gr_item,
        ...errors_gr_item_account_assignment,
        ...errors_gr_service,
        ...errors_gr_serviceline,
        ...errors_gr_serviceline_account_assignmnet
    }

    console.groupEnd()

    return errors
}

const validate_ServiceLineModal=(datas)=>{
    console.group("validate_ServiceLineModal")
    console.log("datas:")
    console.log(datas)

    let errors=[]
    let errors_gr_serviceline=[]
    let errors_gr_serviceline_account_assignmnet=[]

    let t_GR_SERVICELINE=datas.t_GR_SERVICELINE
    let t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT=datas.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT

    //## Service  ##
    // if(t_GR_SERVICE){
    //     t_GR_SERVICE.forEach((item)=>{
    //     if(parseInt(item.checked)===1){
    //         errors_gr_service =checkRequired(item, Tags_GR_SERVICE)

    //         if(t_GR_SERVICELINE){
    //             const t_GR_SERVICELINE_filterd=t_GR_SERVICELINE
    //             .filter(f=>parseInt(f.checked)===1 
    //             && f.service_item_no===item.service_item_no)

    //             errors_gr_serviceline=checkRequired(t_GR_SERVICELINE_filterd,Tags_GR_SERVICELINE)
           
    //             if(t_GR_SERVICELINE_filterd && t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT){
    //                 const t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT_filterd=t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
    //                 .filter(f=>parseInt(f.checked)===1 
    //                 && f.item_no === item.service_item_no
    //                 && f.acc_id === item.service_line_no)

    //                 errors_gr_serviceline_account_assignmnet=checkRequired(t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT_filterd,Tags_GR_SERVICELINE_ACCOUNT_ASSIGNMENT)
    //             }
    //         }
    //     }
    // })
    // }
    //## End of Service  ##

    errors={
        ...errors_gr_serviceline,
        ...errors_gr_serviceline_account_assignmnet
    }

    console.groupEnd()

    return errors
}

const validate_IR=(datas) =>{
    console.group("validate_IR")
    console.log("datas:")
    console.log(datas)

    let errors=[]
    let errors_ir_detail=[]
    let errors_ir_item=[]
    let errors_ir_item_account_assigment=[]

    let t_IR_DETAIL=datas.t_IR_DETAIL
    let t_IR_ITEM=datas.t_IR_ITEM
    let t_IR_ITEM_ACCOUNT_ASSIGNMENT=datas.t_IR_ITEM_ACCOUNT_ASSIGNMENT

    errors_ir_detail=checkRequired(t_IR_DETAIL,Tags_IR_DETAIL,Tags_IR_DETAIL)
    errors_ir_item=checkRequired(t_IR_ITEM,Tags_IR_ITEM,Tags_IR_ITEM)
    errors_ir_item_account_assigment=checkRequired(t_IR_ITEM_ACCOUNT_ASSIGNMENT,Tags_IR_ITEM_ACCOUNT_ASSIGNMENT)

    errors={
        ...errors_ir_detail,
        ...errors_ir_item,
        ...errors_ir_item_account_assigment
    }

    console.groupEnd()

    return errors
}

const validate_MR=(datas)=>{
    console.group("validate_MR")
    console.log("datas:")
    console.log(datas)

    let errors=[]
    let errors_mr_detail=[]
    let errors_mr_attachments=[]
    let errors_mr_vendor=[]

    let t_MR_DETAIL=datas.t_MR_DETAIL
    let t_MR_ATTACHMENTS=datas.t_MR_ATTACHMENTS
    let t_MR_VENDOR=datas.t_MR_VENDOR

    errors_mr_detail=checkRequired(t_MR_DETAIL,Tags_MR_DETAIL)
    errors_mr_attachments=checkRequired(t_MR_ATTACHMENTS,Tags_MR_ATTACHMENTS)
    errors_mr_vendor=checkRequired(t_MR_VENDOR,Tags_MR_VENDOR)

    errors={
        ...errors_mr_detail,
        ...errors_mr_attachments,
        ...errors_mr_vendor
    } 

    console.groupEnd()

    return errors
}

const validate_MOM=(datas)=>{
    console.group("validate_MOM")
    console.log("datas:")
    console.log(datas)

    let errors=[]
    let errors_mr_detail=[]
    let errors_mr_attachments=[]
    let errors_mr_vendor=[]

    let t_MR_DETAIL=datas.t_MR_DETAIL
    let t_MR_ATTACHMENTS=datas.t_MR_ATTACHMENTS
    let t_MR_VENDOR=datas.t_MR_VENDOR

    errors_mr_detail=checkRequired(t_MR_DETAIL,Tags_MR_DETAIL)
    errors_mr_attachments=checkRequired(t_MR_ATTACHMENTS,Tags_MR_ATTACHMENTS)
    errors_mr_vendor=checkRequired(t_MR_VENDOR,Tags_MR_VENDOR)

    errors={
        ...errors_mr_detail,
        ...errors_mr_attachments,
        ...errors_mr_vendor
    } 

    console.groupEnd()

    return errors
}

const validate_All=(datas)=>{
    let errors=[]

    errors=[
        ...validate_GR(datas),
        ...validate_IR(datas),
        ...validate_MR(datas),
        ...validate_MOM(datas)
    ]

    return errors
}

tagsConfigHelper.findTagConfig=findTagConfig
tagsConfigHelper.validate_GR = validate_GR
tagsConfigHelper.validate_IR = validate_MR
tagsConfigHelper.validate_MR = validate_MR
tagsConfigHelper.validate_MOM = validate_MOM
tagsConfigHelper.validate_All = validate_All
tagsConfigHelper.validate_ItemModal = validate_ItemModal
tagsConfigHelper.validate_ServiceLineModal = validate_ServiceLineModal

export default tagsConfigHelper